<template>
  <div class="root">
    <TableBlock ref="tableData" @checkVal="selectVal" :columns="colums" :topWidth="30" :action="action" :param="formData" :navHeight="487" :topHegiht="350">
      <div class="common-items-center common-space-between" style="margin-bottom: 16px;">
               <div class="common-items-center"> 
                  <el-input style="margin-right: 10px;width: 300px;" placeholder="姓名/用户账号/手机号" v-model="formData.keyWord"></el-input>
                  <el-button type="primary"  @click="serachBtn">查询</el-button>
                  <el-button   @click="resetBtn">重置</el-button>
               </div>
               <div>
               <el-button type="primary" class="add-btn" @click="operateShow(2)" style="padding:10px">导出</el-button>
              </div>
      </div>
    </TableBlock>

       <!-- <div>
           <div class="common-items-center common-space-between" style="margin-bottom: 16px;">
               <div class="common-items-center"> 
                  <InputBlock  ref="keyWord"  keyVal="keyWord"   right="20"   paddButtom="0"  @getVal="getVal" width="300" placeholder="请输入姓名、账号、手机号"/>
                  <el-button type="primary"  @click="serachBtn">查询</el-button>
                  <el-button   @click="resetBtn">重置</el-button>
               </div>
               <div>
               <el-button type="primary" class="add-btn" @click="operateShow(2)" style="padding:10px">导出</el-button>
              </div>
           </div>
          
       </div>
       <el-dialog :show-close="true" @close="setIsShow(false)" title="邀请成员" :visible.sync="isShow" width="28%" :close-on-click-modal	="false">
          <makeover ref="makeover" :data="edits" :index="2"></makeover>
          <span slot="footer" class="dialog-footer">
            <el-button @click="setIsShow(false)">取 消</el-button>
            <el-button type="primary" @click="click">确 定</el-button>
          </span>
        </el-dialog> -->
      </div>
</template>

<script>
import {operate} from '@/utils/config'
import {postFun} from '@/utils/httpFun'
import {columns} from './columns'
import axios from 'axios'
import {downFile} from '@/utils/util'
import makeover from '../components/block_makeover.vue'

export default {
  name: 'index',
  components:{
    makeover
  },
  props:{
    edits:{
      type:Object,
      default:()=>{}
    }
  },
  data:()=>({
    action:operate.GETPROJECTMEMBER,
    colums:'',
    tableData: [],
    formData:{
      keyWord:'',
      projectId:''
    },
    addressName:'',
    codeAddress:'',
    list:[ 
      { indexNo: '1', selectName: '有'}, 
      { indexNo: '0', selectName: '无'}
    ],
    dialog:{
      title:'',
      value:''
    },
    dialogVisible:false,
    isShow:false,
    personnelList:[]
  }),
  created(){
    // this.getDatas()
    this.colums = columns(this);
    this.formData.projectId = this.edits.id;
    this.THeight = this.$store.state.windowHeight - 420
    this.$bus.$off('personnel-close')
    this.$bus.$on('personnel-close',res=>{
      this.getDatas();
      this.setIsShow(false);
    })
  },
  methods:{
    selectVal(e){
      this.personnelList = e;
    },
    close(){
      this.isShow = false
    },
    click(){
      this.$refs.makeover.submit();
    },
    fileExport(){

      let personnels = [];

      this.personnelList.forEach(item=>{
        personnels.push(item.projectSubId);
      })

      let param = {
        ...this.formData,
        projectSubIds:personnels
      }

      axios({
        method:'post',
        headers: { 'Authorization':localStorage.getItem('YunWeiTikenBRJ') },
        responseType: 'arraybuffer',
        url:operate.EXPORTPROMEMBER,
        data:param
      }).then(res=>{
        console.log('导出成员管理',res)
        if(!!res && res.status == 200){
          downFile(res.data,'成员管理','xlsx')
        }else if(!!res){
          this.$message.warning(res.message)
        }
      }).catch(err=>{
        console.log('报错',err);
        this.$message.warning(err.message);
      })
    },
    // 操作
    operateShow(index,row){

      switch(index){
        case 1:
          // this.$refs.makeover.getPersonnelList();
          this.isShow=true;
          this.$nextTick(()=>{
            this.$bus.$emit('getPersonnelList');
          })
          
        break;
        case 2:
          this.fileExport();
        break;
        case 3:
          this.$confirm('是否删除移除?', '移除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(async () => {
                let param = {
                  id:row.projectSubId,
                  projectId: this.edits.id
                }
                console.log("删除",param)
                await postFun(url.PROJECT.REMOVEMEMVER,param,res=>{
                  if(res.data){
                    this.$message.success("删除成功");
                  }else if(!res.data){
                    this.$message.warning("删除失败");
                  }else {
                    this.$message.warning("网络繁忙")
                  }
                  this.getDatas()
                })
              })
        break;
      }

     
    },
    //获取所有的数据
    //查询
    serachBtn(){
      this.tableData = []
      this.$nextTick(res=>{
           this.$refs.tableData.getDatas() 
       })
    },
    
    //重置
    resetBtn(){
      this.tableData = []
      this.formData.keyWord = ''
       this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
    },
    setIsIf(isIf){
      this.index = "";
      this.isIf = isIf;
      if(isIf){
        this.$refs.indexList.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__header{
 
  height: 23px;
  background: #F8F9FA;
  box-shadow: 0px 1px 0px 0px rgb(237 238 240);
  border-radius: 12px 12px 0 0;
  }
  ::v-deep .el-dialog{
  border-radius: 12px;
  }
</style>